class locationService extends CrudManager {
    path = '/realestate/lazy-search';
}

angular
    .module('app')
    .service('locationService', [...locationService.$inject, locationService]);
